import './styles.css';

const Me = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Me component');
    }

    const scrollToEducation = () => {
        const educationSection = document.getElementById('education-section');
        if (educationSection) {
            educationSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="mainArea transition-effect" id="me-section">
            <div className="me transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="About Me Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent ">
                            <div className="sectionTitle">
                                About Me
                            </div>

                            <div className="leftText">
                                <b>Mail : </b> avilol9440@gmail.com
                            </div>
                            <div className="leftText">
                                <b>Contact : </b> +91 XXXXX-X1731
                            </div>
                            <div className="leftText">
                                <b>Residence : </b> New Delhi, India
                            </div>

                            <img
                                src="/images/siteElements/scroll-down-short.png"
                                alt="Scroll Down Indicator"
                                className="meScrollDown"
                                onClick={scrollToEducation}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                        <div className="rightContent">
                            <p className="aboutMeText">
                                Hello, I'm Aviral, a dual degree CS student at IIIT Hyderabad. I'm pursuing
                                my UG thesis under Prof. Karthik Vaidhyanathan at SERC, where I try to look
                                serious enough to pass as a researcher.
                                <br />
                                <br />
                                Somewhere between npm install, uv run and existential crisis, I got decent at
                                building things that sometimes sneak their way to deployment and trick users
                                into good experience.
                                <br />
                                <br />
                                When copilot is not available (most likely due to yet another cloudflare outage),
                                you'll find me watching Formula 1, binging documentaries or playing video games.
                                I also enjoy trying new things: places, food, hobbies, life decisions I'll regret
                                in a week.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/aboutMe/pfp.png"
                        alt="About Me Right"
                        className="rightImg"
                    />
                </div>

            </div>
        </div>
    );
};

export default Me;